import firebase from 'firebase';

const auth = {
    namespaced: true,
    state: () => ({
        isLoggedIn: false
    }),
    mutations: {
        login(state, user, claims) {
            state.isLoggedIn = true;
            console.log('auth/login called  with,', user, claims);
        },
        logout(state) {
            state.isLoggedIn = false;
        }
    },
    actions: {
        signOut: function (context) {

            firebase
                .auth()
                .signOut()
                .then(function () {
                    // Sign-out successful.
                    console.log(" // Sign-out successful.");

                    context.commit('logout');
                    //self.state.isAdmin = false;

                })
                .catch(function (error) {
                    // An error happened.
                    console.log("// An error happened. when sign out", error);
                });

        },
        signIn: function (context) {
            context.commit('login');
        }
    }

}

export default auth